/**
 * Created by mgoria on 1/29/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameworkEvent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _AbstractEvent2 = require('./AbstractEvent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Framework event level
 */
let FrameworkEvent = exports.FrameworkEvent = function (_AbstractEvent) {
  _inherits(FrameworkEvent, _AbstractEvent);

  /**
   * @param {Array} args
   */
  function FrameworkEvent() {
    var _ref;

    _classCallCheck(this, FrameworkEvent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = FrameworkEvent.__proto__ || Object.getPrototypeOf(FrameworkEvent)).call.apply(_ref, [this].concat(args)));
  }

  /**
   * @returns {String}
   */


  _createClass(FrameworkEvent, [{
    key: 'getEventLevel',
    value: function getEventLevel() {
      return _AbstractEvent2.AbstractEvent.FRAMEWORK_EVENT_LEVEL;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this._data;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'getValidationSchema',
    value: function getValidationSchema() {
      return _joi2.default.object().keys({
        depthLevel: _joi2.default.number().integer().optional(),
        eventLevel: _joi2.default.string().required().allow([_AbstractEvent2.AbstractEvent.FRAMEWORK_EVENT_LEVEL]),
        service: _joi2.default.string().required().allow(_AbstractEvent2.AbstractEvent.SERVICES),
        resourceType: _joi2.default.string().required().allow(_AbstractEvent2.AbstractEvent.RESOURCE_TYPES),
        resourceId: _joi2.default.string().required(),
        eventName: _joi2.default.string().required(),
        eventId: _joi2.default.string().alphanum().optional(),
        time: _joi2.default.number().integer().required(),
        context: _joi2.default.string().required().allow(_AbstractEvent2.AbstractEvent.CONTEXTS),
        memoryUsage: _joi2.default.object().unknown().optional().default({}),
        payload: _joi2.default.object().unknown().optional().default({}),
        metadata: _joi2.default.object().unknown().optional().default({}),
        environment: _joi2.default.object().unknown().optional().default({}),
        requestId: _joi2.default.string(),
        mainRequestId: _joi2.default.string().optional(),
        identityId: _joi2.default.string().required()
      });
    }
  }]);

  return FrameworkEvent;
}(_AbstractEvent2.AbstractEvent);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RUM/FrameworkEvent.js
// module id = 406
// module chunks = 0